<template>
    <div style="text-align: center">
      <h1 style="text-align: left;padding:50px 120px">专辑:</h1>
      <div @click="typeClick(index,i)" v-for="(i,index) in typeData" :key="i.id" style="overflow: hidden;position: relative;margin: 20px; width: 300px;height: 350px;box-shadow: 0 0 5px #888888;border-radius:10px; display: inline-block">
        <div><img :src="i.pic" width="300" style="position:absolute;clip: rect(100px 300px 350px 0px);top:-100px;left: 0px"></div>
        <div style="color:black;font-size:18px;font-weight:bold;padding-top: 500px;position:absolute;top:-220px;left: 50px">{{i.name}}</div>
      </div>
    </div>
</template>

<script>
  import {ajaxFetch} from '../utils'
  export default {
    name: 'AlbumPage',
    data () {
      return {
        typeData:[],
      }
    },
    mounted: function () {
      this.getTypeData()
    },
    methods: {
      getTypeData: function () {
        ajaxFetch('post','/client/paperCategory/list',{type: 3},(response) => {
          if (response.code === 200) {
            this.typeData = response.data
          } else {

          }
        }, (err) => {
          console.log(err)
        } )
      },
      typeClick: function(index, obj) {
        this.$router.push({name: 'albumPageDetail', query: {id: obj.id, name:obj.name}})
      },
  }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AlbumPage.vue